<div nz-row class="navbar" cdkOverlayOrigin #menuAnchor="cdkOverlayOrigin">
    <div nz-col [hidden]="layoutSmall">
        <app-sidebar-trigger #trigger [(isOpen)]="isSidebarOpen"></app-sidebar-trigger>
    </div>
    <div nz-col *ngIf="!currentUser?.whiteLabel || currentUser?.whiteLabel?.showEhLogo">
        <div class="navbar__logo-eh">
            <app-logo></app-logo>
        </div>
    </div>
    <div nz-col nzFlex="1">
        <a class="navbar__logo-project" routerLink="/">
            <app-logo-project></app-logo-project>
        </a>
    </div>
    <div nz-col *ngIf="currentUser?.whiteLabel && !layoutSmall">
        <div class="navbar__logo-partner">
            <img nz-image [nzSrc]="getPartnerLogoUrl(currentUser?.whiteLabel)" alt="Logo partnera aplikacji" />
        </div>
    </div>
    <app-chatbot></app-chatbot>
    <div *ngIf="!layoutSmall" nz-col class="navbar__user-menu">
        <app-navbar-user-menu></app-navbar-user-menu>
    </div>
    <div nz-col [hidden]="!layoutSmall">
        <app-sidebar-trigger [(isOpen)]="isSidebarOpen" [mobileMode]="true"></app-sidebar-trigger>
    </div>
</div>
<app-sidebar [(isOpen)]="isSidebarOpen" [anchor]="menuAnchor" [trigger]="triggerElement"></app-sidebar>
